/**
 * Article "back to blog": fixed pill at bottom of viewport until the in-flow slot
 * scrolls into view, then docks in normal document position.
 */
(function () {
  const wrap = document.querySelector('[data-article-back-floating]');
  if (!wrap) return;

  const inner = wrap.querySelector('.article-template__back');
  if (!inner) return;

  const FLOAT_CLASS = 'article-template__back-wrap--floating';
  /** px: slot top must be at or above this line from viewport bottom to dock */
  const dockViewportPx = 24;
  let rafId = 0;

  function syncFloatingState() {
    rafId = 0;

    const floating = wrap.classList.contains(FLOAT_CLASS);
    const rect = wrap.getBoundingClientRect();
    const shouldFloat = rect.top > window.innerHeight - dockViewportPx;

    if (shouldFloat && !floating) {
      wrap.style.minHeight = `${Math.ceil(inner.offsetHeight)}px`;
      wrap.classList.add(FLOAT_CLASS);
      return;
    }

    if (!shouldFloat && floating) {
      wrap.classList.remove(FLOAT_CLASS);
      wrap.style.minHeight = '';
      return;
    }

    if (shouldFloat && floating) {
      wrap.style.minHeight = `${Math.ceil(inner.offsetHeight)}px`;
    }
  }

  function schedule() {
    if (rafId) return;
    rafId = requestAnimationFrame(syncFloatingState);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);

  syncFloatingState();
})();
